require('/opt/odin/app/frontend/components/new_faq/index.module.scss');module.exports = "../../app/cells/components/new_faq/show.erb";